import React, { useContext, useMemo, useState, useEffect } from "react";
import { Layout } from "antd";
import Footers from "../footers/footers";
import Sidebarr from "../sidebar/sidebar";
import Headers from "../headers/headers";
import RightDrawer from "../rightDrawer/RightDrawer";
import { SocketContext } from "../../context/socketContext";
import Marquee from 'react-fast-marquee';
import BottomTabs from "../bottomTabs";
import { VISITOR_CHAT_DRAWER_WIDTH, VISITOR_CHAT_DRAWER_WIDTH_COMPACT } from "../dragableModal/dragableModal";
const { Content } = Layout;
const MOBILE_MAX = 767;

const Layouts = ({ AllActiveVisitors, setAllActiveVisitors, children, collapsed, setCollapsed, visitorDrawerCompact }) => {
  const { connected } = useContext(SocketContext);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" && window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  useEffect(() => {
    if (isMobile) setCollapsed(true);
  }, [isMobile, setCollapsed]);

  const visitorDrawerOpen = useMemo(
    () => AllActiveVisitors?.length > 0 && AllActiveVisitors.some((v) => !v.minimized),
    [AllActiveVisitors]
  );

  const visitorDrawerInset = useMemo(() => {
    if (!visitorDrawerOpen) return 0;
    return visitorDrawerCompact ? VISITOR_CHAT_DRAWER_WIDTH_COMPACT : VISITOR_CHAT_DRAWER_WIDTH;
  }, [visitorDrawerOpen, visitorDrawerCompact]);

  const siteLayoutStyle = useMemo(
    () => ({
      paddingLeft: collapsed ? 80 : 200,
      paddingRight: visitorDrawerInset,
      transition:
        "padding-left 0.5s ease, padding-right 0.28s cubic-bezier(0.4, 0, 0.2, 1)",
      position: "relative",
      minWidth: 0,
      boxSizing: "border-box",
    }),
    [collapsed, visitorDrawerInset]
  );

  return (
    <Layout className="layout">
      <Sidebarr collapsed={collapsed} setCollapsed={setCollapsed} isMobile={isMobile} />
      <Layout style={siteLayoutStyle} className="site-layout">

        <div style={{ zIndex: 1 }}>
          <Headers
            collapsed={collapsed}
            setCollapsed={setCollapsed}
            isMobile={isMobile}
          />
        </div>
        <Content className="content">
          {/* {!connected && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backdropFilter: 'blur(5px)',
                backgroundColor: 'rgba(255, 255, 255, 0.5)',
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div
                style={{ width: '100%' }}> <p style={{ color: "red", fontSize: 18, }} > <Marquee>
                  Connecting to Server... Please Wait...
                </Marquee></p></div>
            </div>
          )} */}
          {children}</Content>
        {/* <RightDrawer /> */}
        <BottomTabs
          AllActiveVisitors={AllActiveVisitors}
          setAllActiveVisitors={setAllActiveVisitors}
          collapsed={collapsed}
          visitorDrawerCompact={visitorDrawerCompact}
        />
        <Footers />
      </Layout>
    </Layout>

  );
};

export default Layouts;
